<template>
  <div class="preview-mask" @click.self="close">
    <!-- 关闭 -->
    <div class="close-btn" @click.stop="close">×</div>
    <!-- 左 -->
    <div class="left-btn" @click.stop="prev"><i class="el-icon-arrow-left"></i></div>
    <!-- 右 -->
    <div class="right-btn" @click.stop="next"><i class="el-icon-arrow-right"></i></div>
    <div class="preview-content">
      <!-- 图片 -->
      <div v-if="current.type === 'image'" class="image-wrapper">
        <img :key="current.id" ref="image" :src="current.image" class="preview-image" @load="initPanzoom" />
      </div>
      <!-- 视频 -->
      <div v-else class="video-wrapper">
        <video ref="video" controls autoplay class="video-player" :poster="current.image" @timeupdate="saveVideoTime">
          <source :src="current.url" type="video/mp4" />
        </video>
      </div>
    </div>
  </div>
</template>

<script>
import Panzoom from '@panzoom/panzoom/dist/panzoom'
export default {
  props: {
    list: Array,
    index: Number
  },

  data() {
    return {
      currentIndex: this.index,
      progressMap: {},
      panzoom: null
    }
  },

  computed: {
    current() {
      return this.list[this.currentIndex]
    }
  },

  mounted() {
    document.body.style.overflow = 'hidden'
    this.loadProgressMap()
    this.initViewer()
  },

  beforeDestroy() {
    document.body.style.overflow = ''
    this.saveProgressMap()
    this.destroyPanzoom()
  },

  methods: {
    initViewer() {
      this.$nextTick(() => {
        if (this.current.type === 'image') {
          const img = this.$refs.image
          if (img && img.complete && img.naturalWidth > 0) {
            this.initPanzoom()
          }
        } else {
          this.restoreVideoTime()
        }
      })
    },

    initPanzoom() {
      this.destroyPanzoom()
      const img = this.$refs.image
      if (!img) return
      this.panzoom = Panzoom(img, {
        minScale: 0.5,
        maxScale: 2,
        startScale: 1
      })
      img.parentElement.addEventListener('wheel', this.handleWheel, {
        passive: false
      })
    },

    handleWheel(e) {
      e.preventDefault()
      if (!this.panzoom) return
      const direction = e.deltaY < 0 ? 1 : -1
      const scale = this.panzoom.getScale() * Math.exp((direction * 0.3) / 3)
      this.panzoom.zoom(scale, { animate: false })
    },

    destroyPanzoom() {
      if (!this.panzoom) return
      const img = this.$refs.image
      if (img && img.parentElement) {
        img.parentElement.removeEventListener('wheel', this.handleWheel)
      }
      this.panzoom.destroy()
      this.panzoom = null
    },

    close() {
      this.saveCurrentVideo()
      this.destroyPanzoom()
      this.$emit('close')
    },

    prev() {
      if (this.currentIndex === 0) {
        return
      }
      this.saveCurrentVideo()
      this.destroyPanzoom()
      this.currentIndex--
      this.initViewer()
    },

    next() {
      if (this.currentIndex >= this.list.length - 1) {
        return
      }
      this.saveCurrentVideo()
      this.destroyPanzoom()
      this.currentIndex++
      this.initViewer()
    },

    saveVideoTime() {
      if (this.current.type !== 'video') {
        return
      }
      const video = this.$refs.video
      this.$set(this.progressMap, this.current.id, video.currentTime)
    },

    saveCurrentVideo() {
      if (this.current.type !== 'video') {
        return
      }
      const video = this.$refs.video
      if (!video) return
      this.$set(this.progressMap, this.current.id, video.currentTime)
      this.saveProgressMap()
      video.pause()
    },

    restoreVideoTime() {
      if (this.current.type !== 'video') {
        return
      }
      this.$nextTick(() => {
        const video = this.$refs.video
        if (!video) return
        video.onloadedmetadata = () => {
          const time = this.progressMap[this.current.id] || 0
          video.currentTime = time
        }
      })
    },

    loadProgressMap() {
      try {
        const saved = localStorage.getItem('historyMediaProgressMap')
        if (!saved) return
        const parsed = JSON.parse(saved)
        if (parsed && typeof parsed === 'object') {
          this.progressMap = parsed
        }
      } catch (err) {
        console.warn('加载视频进度失败', err)
      }
    },

    saveProgressMap() {
      try {
        localStorage.setItem('historyMediaProgressMap', JSON.stringify(this.progressMap))
      } catch (err) {
        console.warn('保存视频进度失败', err)
      }
    }
  }
}
</script>
<style scoped lang='scss'>
.preview-mask {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  justify-content: center;
  align-items: center;
}

.preview-content {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.image-wrapper {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

.preview-image {
  display: block;
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 80%;
  box-sizing: border-box;
  border: 0.625vw solid #fff;
  user-select: none;
  cursor: grab;
  touch-action: none;
}

.preview-image:active {
  cursor: grabbing;
}

.video-wrapper {
  width: 80vw;
  height: 80vh;
  background: #fff;
  padding: 20px;
  box-sizing: border-box;
}

.video-player {
  width: 100%;
  height: 100%;
}

.close-btn {
  position: fixed;
  right: 40px;
  top: 40px;
  width: 3.6458vw;
  height: 3.6458vw;
  border-radius: 50%;
  background: #fff;
  font-size: 2.5375vw;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10000;
}

.left-btn,
.right-btn {
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  width: 3.6458vw;
  height: 3.6458vw;
  border-radius: 50%;
  background: #fff;
  font-size: 1.5375vw;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10000;
}

.left-btn {
  left: 40px;
}

.right-btn {
  right: 40px;
}
</style>
